import type { Components, Theme } from '@mui/material/styles';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiTab: {
    styleOverrides: {
      root: {
        padding: '9px 12px',
        fontSize: '.6rem',
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
      }),
    },
  },
};
